import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const getRoot = document.getElementById('root');
const root = createRoot(getRoot);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();